import React from 'react';
import { useTranslation } from "react-i18next";
import { convertDistance } from '../../utils/distanceConverter';

const ScorecardTable = React.memo(({ 
  holes, 
  selectedHole, 
  onHoleClick, 
  unit, 
  isMobile, 
  selectedTee, 
  onTeeChange 
}) => {
  const { t } = useTranslation();

  return (
    <table className="glfr-sc-scorecard-table">
      <thead>
        <tr className="glfr-sc-scorecard-header-row">
          <th className="glfr-sc-scorecard-header">{t('hole')}</th>
          <th className="glfr-sc-scorecard-header">{t('par')}</th>
          <th className="glfr-sc-scorecard-header">{t('index')}</th>
          {isMobile ? (
            <th className="glfr-sc-scorecard-header">
              <span
                className="glfr-sc-tee-color-circle"
                style={{
                  color:
                    holes.length > 0 && holes[0].tees
                      ? holes[0].tees.find((tee) => tee.name === selectedTee)
                          ?.color
                      : undefined,
                }}
              >
                ●
              </span>
              <select
                value={selectedTee}
                onChange={(e) => onTeeChange(e.target.value)}
                className="glfr-sc-tee-dropdown"
              >
                {holes.length > 0 &&
                  holes[0].tees &&
                  holes[0].tees.map((tee, index) => (
                    <option key={index} value={tee.name}>
                      {tee.name}
                    </option>
                  ))}
              </select>
            </th>
          ) : (
            <>
              {holes.length > 0 &&
                holes[0].tees &&
                holes[0].tees.map((tee, index) => (
                  <th key={index} className="glfr-sc-scorecard-header">
                    {tee.name}
                    <span style={{ color: tee.color }}> ● </span>
                  </th>
                ))}
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {holes.map((hole, index) => {
          const holeNumber = index + 1;
          return (
            <tr
              key={index}
              onClick={() => onHoleClick(holeNumber)}
              className={`glfr-sc-scorecard-row ${
                holeNumber === selectedHole ? "highlight" : ""
              }`}
            >
              <td className="glfr-sc-scorecard-cell">{index + 1}</td>
              <td className="glfr-sc-scorecard-cell">{hole.tees[0].par}</td>
              <td className="glfr-sc-scorecard-cell">
                {hole.tees[0].handicap}
              </td>
              {isMobile ? (
                <>
                  {hole.tees
                    ? (() => {
                        const tee = hole.tees.find(
                          (tee) => tee.name === selectedTee
                        );
                        return tee ? (
                          <td key={tee.name} className="glfr-sc-scorecard-cell">
                            {convertDistance(tee.distance, unit)}
                          </td>
                        ) : null;
                      })()
                    : null}
                </>
              ) : (
                <>
                  {hole.tees.map((tee, index) => (
                    <td key={index} className="glfr-sc-scorecard-cell">
                      {convertDistance(tee.distance, unit)}
                    </td>
                  ))}
                </>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
});

ScorecardTable.displayName = 'ScorecardTable';

export default ScorecardTable; 